define(['jquery'], function($) {
	facetPanels = {
		Init: function () {
            //declare vars
            this.$panelHeading = $('.score-facet-panel .panel-heading');
            this.$panelBody = $('.score-facet-panel .panel-body');
            //change initial facet panel values
            facetPanels.closePanel();
        },
        closePanel: function() {
            facetPanels.$panelHeading.removeClass('opened').attr('aria-expanded','false');
            facetPanels.$panelBody.hide();
        }
    }

    return facetPanels;
});
